export default "__VITE_ASSET__BfEgwrq1__"